import {axios} from "~/plugins/axios";

const getDefaultState_formReport = () => {
  return {
    report: [],
  }
}
const state = getDefaultState_formReport();

const getters = {
  report: state => state.report,
}

const actions = {
  async loadFormReport({ commit }, payload) {
    commit('shared/SET_LOADING', true, {root: true})

    let headers = {}
    try {
      if (payload.excel === true) {
        headers = {
          responseType: "blob",
        }
      }

      let resp = await axios.post('/api/reports/helpers/callCards', payload, headers)
      if (payload.excel === true) {
        this._vm.utils.downloadXlsx(resp)
      } else {
        commit('SET_REPORT', resp.data)
      }

      commit('shared/SET_LOADING', false, {root: true})

      return resp.data;

    } catch (err) {
      commit('shared/SET_ERROR', err.response.data, {root: true})
      commit('shared/SET_LOADING', false, {root: true})

      throw err
    }
  },

  async loadRatioCallsToCards({ commit }, payload) {
    try {
      let resp = await axios.post('/api/reports/helpers/get-ratio-calls-to-cards', payload)
  
      return resp.data
    } catch (error) {
      commit('shared/SET_ERROR', error.response.data, {root: true})
      throw error
    }
  },
}

const mutations = {
  SET_REPORT(state, items) {
    state.report = items;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
